import React from "react";

const Dump = props => (
    <div style={{width: "100%", maxHeight: "800px", zIndex: 1000, overflow: "auto", backgroundColor: "lightGrey", textAlign: "left", padding: "10px"}}>
        <pre>{JSON.stringify(props.data, null, 2)}</pre>
    </div>
);

export default Dump;
